/* clone-rv-pdp-reviews — carousel review: cuộn ngang có snap (vuốt trên mobile), mũi tên trước/sau
   (mỗi lần 1 thẻ, tắt ở hai đầu như Replo), thanh tiến trình trên mobile/tablet. */
(function () {
  if (customElements.get('rv-pdp-reviews-carousel')) return;

  class RvPdpReviewsCarousel extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.viewport = this.querySelector('[data-viewport]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.viewport || !this.slides.length) return;

      this._onScroll = () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = null;
          this.update();
        });
      };
      this.viewport.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll);

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.index() - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.index() + 1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot)));
      });

      this.update();
    }

    disconnectedCallback() {
      if (this.viewport) this.viewport.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      this._bound = false;
    }

    offsetOf(i) {
      var first = this.slides[0];
      return this.slides[i].offsetLeft - first.offsetLeft;
    }

    maxScroll() {
      return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    }

    index() {
      var left = this.viewport.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < this.slides.length; i++) {
        var d = Math.abs(this.offsetOf(i) - left);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      }
      return best;
    }

    goTo(i) {
      var n = Math.max(0, Math.min(this.slides.length - 1, i));
      this.viewport.scrollTo({ left: Math.min(this.offsetOf(n), this.maxScroll()), behavior: 'smooth' });
    }

    update() {
      var left = this.viewport.scrollLeft;
      var max = this.maxScroll();
      var atEnd = left >= max - 2;
      var current = atEnd ? this.slides.length - 1 : this.index();
      if (this.prevBtn) this.prevBtn.disabled = left <= 2;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
      this.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }
  }

  customElements.define('rv-pdp-reviews-carousel', RvPdpReviewsCarousel);

  /* Theme editor: chọn block review thì cuộn tới thẻ đó */
  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target;
    if (!slide.hasAttribute || !slide.hasAttribute('data-slide')) return;
    var carousel = slide.closest('rv-pdp-reviews-carousel');
    if (carousel && carousel.goTo) carousel.goTo(carousel.slides.indexOf(slide));
  });
})();
